<template>
<ul class="related-one">
  <li v-if="value">
    <button class="btn btn-danger" @click.prevent="removeItem" v-if="!dbfield.default">
      <i :class="'fas fa-xmark'"></i>
    </button>
    <DataForm v-if="dbfield?.cascade=='delete'" :params="{type}" :item="value" />
    <span class="value" v-if="!dbfield.default">{{ value?.username || value?.name || value?.title || value?.uuid || value?.id }}</span>
  </li>
  <li class="new" v-else>
    <button class="btn btn-primary" @click.prevent="addNew" v-if="dbfield?.cascade=='delete'"><i :class="'fas fa-plus'"></i></button>
    <button class="btn btn-primary" @click.prevent="selectItem" v-if="dbfield?.cascade!='delete'"><i :class="'fas fa-plus'"></i></button>
  </li>
</ul>
</template>

<script>
export default {
  props: ["modelValue", "field", "item", "field", "dbfield"],
  data: ()=>({
    value: null,
  }),
  watch: {
    value: {
      handler() {
        this.$emit("update:modelValue", this.value);
      },
    },
    modelValue: {
      handler() {
        this.value=this.modelValue;
      }, immediate: true,
    },
  },
  computed: {
    type() {
      return this.dbfield.target;
    },
    fieldDesc() {
      return this.stores.auth.typeDesc?.[this.type] ?? {};
    },
  },
  methods: {
    createLink(type) {
      return {
        name: "page",
        params: {
          path: [...this.$route.params.path, type],
        }
      }
    },
    addNew() {
      var newItem={};
      for(var field in this.fieldDesc) {
        if (field!=this.dbfield.name)
          newItem[field]=null;
      }
      this.value=newItem;
    },
    selectItem() {
      this.stores.callbacks.pushCallback((...args)=>this.select(...args));
      this.$router.push(this.createLink(this.dbfield.target));
    },
    select(item) {
//       this.stores.callbacks.popCallback();
      var item2={uuid: item.uuid, id: item.id};
      for(var field of ["username", "name", "title", "slug"])
        if (item[field])
          item2[field]=item[field];
      this.value=item2;
    },
    removeItem(index) {
      this.value=null;
    },
  },
  mounted() {
    if (this.dbfield.default && this.value==null)
      this.addNew();
  },
}
</script>
